import { createSelector } from 'reselect'

import { selectGlobalPartnerData } from './selectGlobalPartnerData'

export const selectGPCountryCodes = createSelector([selectGlobalPartnerData], (data) =>
  data ? data.countryCodes : []
)
